<template>
    <div class="meetingplan-application">
        <div class="fix-header">
            <div class="contain-block search-content-block">
                <div class="search-content">
                    <common-select iconType="trigle" :defaultValue="searchMainData.year" @change="handleMainSearch()" v-model="searchMainData.year" :datas="baseDataRecords.Year" :textKey="'yearName'" :valueKey="'id'">
                    </common-select>
                    <div v-for="(quarter, index) in searchMainQuarters" :key="index" :class="['search-content-quarter', searchMainData.quarter == quarter?'search-content-quarter-active':'']">
                        <label @click="handleMainSearch(quarter)">{{quarter}}</label>
                    </div>
                    <div class="add-btn">
                        <mt-button :disabled="!canCreateMeeting" plain type="primary" :loading="false" @click="handleAddClick">添加会议</mt-button>
                    </div>
                </div>
            </div>
            <div class="contain-block application-status-block">
                <div class="application-status">
                    <div @click="handleStatusChange(item)" v-for="item in myStatusWithOutCancle" :key="item.value" :class="['status', item.value==searchData.status?'status-active':'']"><div>{{item.text}}</div></div>
                </div>
            </div>
        </div>
        <div ref="wrapper" class="scroll-content" :style="{height: contentH + 'px'}">
            <div class="contain-block summary">
                <div class="summary-info"><label class="summary-info-title">计划会议预算：</label><label class="summary-info-value">CNY {{mainData[searchData.status]?mainData[searchData.status].totalAmountStr:''}}</label></div>
                <div class="summary-info"><label class="summary-info-title">计划会议场次：</label><label class="summary-info-value">{{mainData[searchData.status]?mainData[searchData.status].count:''}} 场</label></div>
            </div>
            <div v-if="mainData[searchData.status] && mainData[searchData.status].count" class="contain-block search-meeting-block">
                <div class="toolbar">
                    <form action="" @submit.prevent="">
                        <input type="search" @keyup.enter="handleSearchEnterKey" placeholder="搜索会议" v-model="searchData.meetingName" />
                    </form>
                    <div class="export-btn">
                        <a href="javascript:void(0)" @click="handlerExportExcelClick">
                            <i class="iconfont icon-daochu"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div v-if="applicationDetailData.length == 0" class="no-items">
                <div class="no-items-block" :style="noItemImg">
                    <label>暂无会议</label>
                </div>
            </div>
            <div v-else class="contain-block detail-table">
                <mt-loadmore :auto-fill="false" :bottom-method="handleLoadMore" :bottom-all-loaded="allLoaded" ref="loadmore">
                    <div>
                        <div class="detail-table-item" v-for="(application, index) in applicationDetailData" :key="index">
                            <div class="detail-table-item-header">
                                <mt-checklist
                                    title=""
                                    v-model="application.selected"
                                    :options="[application.meetingName]"
                                    @change.native="handleCheckItemChange"
                                >
                                    </mt-checklist>
                                <div v-show="application.meetingWebStatus == '待提交'" class="detail-table-item-header-copy">
                                    <span class="iconfont icon-copy1" @click="handleCopyClick(application)"></span>
                                </div>
                            </div>
                            <div class="detail-table-item-row">
                                <div class="detail-table-item-total-amount"><label class="detail-table-item-total-amount-title">计划预算：</label><label class="detail-table-item-total-amount-value">CNY {{application.totalAmountStr}}</label></div>
                            </div>
                            <div class="detail-table-item-row">
                                <div class="detail-table-item-col-info item-info">{{formatBaseData(application,'meetingSystem')}}</div><span class="item-info-split">/</span>
                                <div class="detail-table-item-col-info item-info">{{formatBaseData(application,'meetingProp')}}</div><span class="item-info-split">/</span>
                                <div class="detail-table-item-col-info item-info">{{formatBaseData(application,'meetingType')}}</div><span class="item-info-split">/</span>
                                <div class="detail-table-item-col-info item-info">{{formatBaseData(application,'productId')}}</div>
                            </div>
                            <div class="detail-table-item-row-spit-line"></div>
                            <div class="detail-table-item-row">
                                <div class="detail-table-item-col-info detail-table-item-col-info-startday">开始日期：{{formatDateTime2Date(application.meetingBeginDate)}}</div>
                                <div class="detail-table-item-col-info-right"><span @click="handleDetailClick(application)">详情&nbsp;<span class="iconfont icon-jiantou_you"></span></span></div>
                            </div>
                        </div>
                    </div>
                </mt-loadmore>
            </div>
            <div class="bottom-info">
                <mt-checklist
                            :class="notAllClass"
                            title=""
                            v-model="allSelected"
                            @change.native="handleCheckAllChange"
                            :options="['全选']">
                            </mt-checklist>
                <div class="bottom-info-info">
                    <div>预算：<label class="bottom-info-value">CNY&nbsp;{{selectedTotalAmount() | MoneyFormat}}</label></div>
                    <div>已选：<label class="bottom-info-value">{{selectedData().length}}</label>&nbsp;场</div>
                </div>
                <div class="bottom-info-operate">
                    <mt-button @click="handleBatchSubmit" :disabled="!canBatchSubmit()" type="primary" :loading="false">提交</mt-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script> 
import { mapGetters } from 'vuex';
import application from '@/api/meetingplan/application';
import * as StorageService from '@/util/StorageService';
import { Checklist, MessageBox, Toast  } from 'mint-ui';

export default {
    components: {
        Checklist
    },
    data() {
        return {
            applicationDetailData :[],
            searchMainData: {
                year: '',
                quarter: 'Q1',
            },
            mainData: {
                '1':{},
                '2':{},
                '4':{},
                '5':{},
            },
            searchData: {
                status:'',
                meetingName: '',
            },
            searchMainQuarters: ['Q1','Q2','Q3','Q4'],
            allSelected: [],
            canCreateMeeting: false,    
            pageData: {
                pageNo: 0,
                pageSize: 10,
                total: 0
            },
            allLoaded: true,
            contentH: 0,
            notAllClass: '',
            noItemImg: {
                backgroundImage: "url(" + require("@/assets/no_items.png") + ")",
            }
        };
    },
  computed: {
    ...mapGetters(['baseDataRecords','basedataGetName','basedataGetNameByRowIdField']),
    myStatusWithOutCancle() {
        return this.baseDataRecords.MyApplicationStatus.filter(function (status) {
            return status.value != '7'
        })
    },       
  }, 
  methods: {
    selectedData() {
        let data = []
        this.applicationDetailData.forEach(app => {
            if(app.selected.length > 0) {
                data.push(app);
            }
        })

        return data;
    },
    formatDateTime2Date(cellValue) {
        if(!cellValue)
            return '';

        return moment(cellValue).format('YYYY-MM-DD');
    },
    formatBaseData(row, column) {
      if(column == 'productId'){
          if(row.productId) {
            let ids = row.productId;
            if(typeof ids == 'string') {
              ids =  ids.split(',');
            }
            let names = []
            for (let pidIndex = 0; pidIndex < ids.length; pidIndex++) {
              names.push(this.basedataGetName('Product', ids[pidIndex]));              
            }     
            return names.join(',')       
          }
          return row.prodIds;
      }
      if(column == 'meetingSystem'){
          if(row.meetingSystem) {
            let ids = row.meetingSystem;
            if(typeof ids == 'string') {
              ids =  ids.split(',');
            }
            let names = []
            for (let pidIndex = 0; pidIndex < ids.length; pidIndex++) {
              names.push(this.basedataGetName('MeetingSystem', ids[pidIndex]));              
            }     
            return names.join(',')       
          }
          return row.prodIds;
      }

      return this.basedataGetNameByRowIdField(column, row);
    },
    handleSearch(pageNo, fromLoadMore) {  
        if(pageNo == 1) {
            this.allSelected = [];
        }
      this.searchData.year = this.searchMainData.year;
      this.searchData.season = this.searchMainData.season;
        
      StorageService.setItem(StorageService.keys.MyApplicationSearchDetailData,JSON.stringify(this.searchData));

      let conditionData = {};
        for (const key in this.searchData) {
            if (this.searchData.hasOwnProperty.call(this.searchData, key)) {
                const element = this.searchData[key];
                if(element || element === 0) {
                    conditionData[key] = element;
                }
            }
        }
        if(conditionData.meetingName) {
            conditionData.meetingName = '*' + conditionData.meetingName + '*';
        }
        conditionData.pageNo = pageNo || this.pageData.pageNo;
        conditionData.pageSize = this.pageData.pageSize;

        if(conditionData.pageNo == 1) {            
            this.applicationDetailData = [];       
        }
      application.list(conditionData)
                .then(res => {
                    res.pageList.records.forEach(el => {
                        el.selected = [];
                        this.applicationDetailData.push(el);
                    })

                    this.pageData.pageNo = res.pageList.current;
                    this.pageData.total = res.pageList.total;

                    this.allLoaded = this.pageData.pageNo*this.pageData.pageSize >= this.pageData.total;
                    if(this.$refs.loadmore) {
                        this.$refs.loadmore.onBottomLoaded();
                    }

                    this.handleCheckItemChange()

                    if(conditionData.pageNo == 1) {
                        this.$nextTick(() => {
                            this.$refs.wrapper.scrollTo(0,0);
                        })
                    }
                })
    },
    initCreateMeetingInfo() {
      application.getCanCreateMeeting({
        year: this.searchMainData.year,
        season: this.searchMainData.season,
      }).then(res => {
        this.canCreateMeeting = res.canCreateMeeting;
      });
    },
    handleMainSearch(quarter, noRefreshDetail) {
        if(quarter) {
            this.searchMainData.quarter = quarter;
            this.searchMainData.season = quarter.replace('Q','');
        }
        StorageService.setItem(StorageService.keys.MyApplicationSearchMainData,JSON.stringify(this.searchMainData));
        application.queryMainApplication(this.searchMainData)
            .then(res => {
                this.mainData = {};
                res.forEach(data => {
                data.statusName = this.basedataGetName('MyApplicationStatus',data.status); 
                this.mainData[data.status.toString()] = data;
                });

                this.initCreateMeetingInfo();
                
                if(!noRefreshDetail) {
                    this.handleSearch(1); 
                }
            })
    },
    handleStatusChange(item) {
        this.searchData.status = item.value;
        this.handleMainSearch();
    },
    handleCheckItemChange() {
        if(this.selectedData().length > 0) {
            this.allSelected = ['全选']

            if(this.selectedData().length == this.applicationDetailData.length) {
                this.notAllClass = ''
            }
            else {
                this.notAllClass = 'not-all'
            }
        } 
        else {
            this.allSelected = [];
            this.notAllClass = ''
        }
    },
    selectedTotalAmount() {
      let amount = 0;
      this.selectedData().forEach(data => {
        amount += data.totalAmount;
      })

      return amount;
    },
    canBatchSubmit() {
      for (let index = 0; index < this.selectedData().length; index++) {
        const element = this.selectedData()[index];
        if(element.meetingWebStatus != '待提交' || element.queueTaskStatus === '排队中'){
          return false;
        }        
      }

      return this.selectedData().length > 0; 
    },    
    confirmTemplate(message, subMessage) {
        var tempate = '';
        if(subMessage) {
            tempate = '<div class="message-alert">'+
                    '<div>'+
                        '<i class="iconfont icon-jingshi"></i>'+
                    '</div>'+
                    '<div class="common-confirm-info-no-bottom">'+
                        message+
                    '</div>'+
                    '<div class="common-confirm-info">'+
                        subMessage+
                    '</div>'+
                '</div>';
        }
        else {
            tempate = '<div class="message-alert">'+
                    '<div>'+
                        '<i class="iconfont icon-jingshi"></i>'+
                    '</div>'+
                    '<div class="common-confirm-info">'+
                        message+
                    '</div>'+
                '</div>';
        }
        return tempate;
    },
    isSeasonlyType() {
        if(this.selectedData() && this.selectedData().length > 0) {
            return this.selectedData()[0].meetingDateType == '1';
        }

        return false;
    },
    handleBatchSubmit() { 
        if(this.isSeasonlyType()) {
            MessageBox({
                message: this.confirmTemplate(`确认提交 ${this.selectedData().length} 场会议申请？`, '该季度的计划申请，需要直线经理和二级审批人审批'),
                title: '',
                cancelButtonText: '返回',
                confirmButtonText: '确认',
                showCancelButton: true,
            }).then((action ) => {
                if(action != 'cancel')
                {
                    this.handlerBatchSubmitConfirmOK()
                }
            });
        }           
        else {
            let tempIds = [];
            this.selectedData().forEach(meeting => {
                tempIds.push(meeting.id);
            })
            application.submitMeetingApprove({
                            year: this.searchMainData.year,
                            season: this.searchMainData.season,
                            id: tempIds.join(',')
                        })
                    .then(res => {
                        MessageBox({
                            message: this.confirmTemplate(`确认提交 ${this.selectedData().length} 场会议申请？`, res),
                            title: '',
                            cancelButtonText: '返回',
                            confirmButtonText: '确认',
                            showCancelButton: true,
                        }).then((action ) => {
                            if(action != 'cancel')
                            {
                                this.handlerBatchSubmitConfirmOK()
                            }
                        });
                    })
        }
    },
    handlerBatchSubmitConfirmOK() {
      let tempIds = [];
      this.selectedData().forEach(meeting => {
        tempIds.push(meeting.id);
      })

      application.batchSubmit({
        year: this.searchMainData.year,
        season: this.searchMainData.season,
        id: tempIds.join(',')
        }).then(res => {
            Toast(res.resultTxt);
          this.handleMainSearch();
        })
    },
    handlerExportExcel(fileName, extendData) {
        let params = null;
        if(this.selectedData().length > 0){
            let ids = [];
            for (const data of this.selectedData()) {
            ids.push(data.id);
            }

            params = {id:ids.join(',')};
        }
        else{
            params = this.searchData;
        }

        if(extendData) {
            _.extend(params, extendData)
        }
        let conditionData = {};
        for (const key in params) {
            if (params.hasOwnProperty.call(params, key)) {
                const element = params[key];
                if(element || element === 0) {
                    conditionData[key] = element;
                }
            }
        }
        
        application.exportXls(conditionData)
                        .then(res => {
                            // 将`blob`对象转化成一个可访问的`url`
                            let url = window.URL.createObjectURL(new Blob([res.data]));
                            let link = document.createElement('a');
                            link.style.display = 'none';
                            link.href = url;
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        })
    },
    handlerExportExcelClick() {
      this.handlerExportExcel('我的申请.xlsx', {meetingFrom: 1});
    }, 
    handleLoadMore() {
        this.handleSearch(this.pageData.pageNo+1,true)
    },
    handleSearchEnterKey() {
        this.handleSearch(1);
    },
    handleCheckAllChange() {
        this.applicationDetailData.forEach(data => {
            if(this.allSelected.length == 0) {
                data.selected = []
            }
            else {
                data.selected = [data.meetingName];
            }
        })
        
        this.handleCheckItemChange()
    },
    handleAddClick(item) { 
      this.$router.push({
        name: 'meetingplan-application-add',
        params: {
          'year':this.searchMainData.year,
          'season':this.searchMainData.quarter.replace('Q','')
          }
      }); 
    },
    handleCopyClick(item) { 
      this.$router.push({
        name: 'meetingplan-application-copy',
        params: {
          'id':item.id,
          }
      }); 
    },
    handleDetailClick(item) {
        let routeName = '' 
        if(item.meetingWebStatus == '待提交') {
            routeName = 'meetingplan-application-edit';
        }
        else if(item.meetingWebStatus == '审批中'){
            
            routeName = 'meetingplan-application-view';
        }
        else {
            routeName = 'meetingplan-application-viewchange';
        }

        this.$router.push({
            name: routeName,
            params: {
                'id':item.id,
            }
        }); 
    },
    resizeLayout() {
        this.contentH = document.documentElement.clientHeight - 
                 this.$refs.wrapper.getBoundingClientRect().top                 
                 - (document.getElementsByClassName('mint-tabbar')[0].clientHeight + document.getElementsByClassName('bottom-info')[0].clientHeight);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeLayout, true)
  },
  mounted() {     
    this.contentH = document.documentElement.clientHeight - 
                 this.$refs.wrapper.getBoundingClientRect().top                 
                 - (document.getElementsByClassName('mint-tabbar')[0].clientHeight + document.getElementsByClassName('bottom-info')[0].clientHeight);

    let searchDetailDataTemp = StorageService.getItem(StorageService.keys.MyApplicationSearchDetailData);
    if(searchDetailDataTemp) {
        this.searchData = JSON.parse(searchDetailDataTemp);
    }
    else{
        this.searchData.status = '1';
    }

    let searchMainDataTemp = StorageService.getItem(StorageService.keys.MyApplicationSearchMainData);

    if(searchMainDataTemp) {
        this.searchMainData = JSON.parse(searchMainDataTemp);
    }
    else{
      this.searchMainData.year = (new Date()).getFullYear().toString();
      this.searchMainData.quarter = 'Q'+Math.ceil(((new Date()).getMonth()+1)/3)
    }

    this.handleMainSearch(this.searchMainData.quarter);

    window.addEventListener('resize', this.resizeLayout, true);
  }
};
</script>

<style lang="less" scoped>
    .search-content-block {
        padding-bottom: 0;
        padding-top: 8px;
    }
    .search-content {
        font-size: 16px;
        display: flex;

        &-quarter {
            height: 24px;
            line-height: 24px;
            padding-bottom: 5px;

            &-active {
                font-weight: bold;
                color: @mainColor;
                border-bottom: 3px solid @mainColor;
            }
        }

        &-quarter + &-quarter {
            margin-left: 20px;
        }

        .common-select + &-quarter {
            margin-left: 20px;
        }
    }

    .application-status-block {
        margin-top: 5px !important;
        padding-top: 6px !important;
        padding-bottom: 6px !important;
    }

    .search-meeting-block {
        margin-top: 0px !important;
        padding-top: 4px !important;
    }

    .common-select {
        font-size: 16px !important;
    }

    .add-btn {
        position: absolute;
        right: 15px;
        top: 4px;

        span {
            width: auto;
            height: 32px;
            border: 0.5px solid @mainColor;
            color: @mainColor;
            font-size: 14px;
            border-radius: 16.5px;
            padding: 5px 12px;
        }
    }

    .application-status {
        font-size: @subSubFontSize;
        color: @subSubFontColor;
        display: flex;
        width: 345px;
        height: 28px;
        background: #f6f6f6;
        border-radius: 14px;

        .status {
            div {
                width: 58px;
                height: 28px;
                line-height: 28px;
                padding: 0px 20px;
                text-align: center;
            }
        }
        .status + .status {
            margin-left: -18px;
        }

        .status-active {
            background-color: @primaryButtonBG;
            color: @primaryButtonText;
            border-radius: 14px;
        }
    }

    .summary {
        font-size: 16px;
        padding-top: 0px !important;

        &-title {
            color:#111111;
            font-weight: bold;
        }

        &-info {
            padding-top: 10px;

            &-title {
                color: @subFontColor;
                font-weight: bold;
            }

            &-value {
                color: @subFontColor;
                font-weight: bold;
            }
        }
    }

    .no-items {
        width: @contentWidth;
        &-block {
            height: 160px;
            width: 160px;
            background-size: 160px 160px;
            margin: 80px auto 0 auto;
            text-align: center;

            label {
                font-size: @invalidFontSize;
                color: @assistFontColor;
                font-weight: @assistFontWeight;
                line-height: 380px;
            }
        }
    }

    .fix-header {
        position: fixed;
        top: 0px;
        background-color: @bgColor;
        z-index: 1;
    }

    .scroll-content {
        margin-top: 85px;
        padding-bottom: 104px;
        overflow-y: auto;
        z-index: 1;
    }

    .toolbar {
        display: flex;

        input {
            height: 36px;
            width: 294px;
            background-color: @bgColor;
            border: 1px solid  @bgColor;
            border-radius: 19px;   
            text-align: center; 
            font-size: 16px;
            background-image: none;
        }
        div {
                width: 36px;
                height: 36px;
                background: @bgColor;
                border-radius: 50%;
                margin-left: 15px;
                text-align: center;
                line-height: 36px;

                i {
                    font-size: 12px;
                }
        }
    }

    .detail-table {
        padding-top: 0px;
        margin-top: -10px !important;
        
        &-item {
            width: 345px;
            height: 140px;
            background: @bgColor;
            border-radius: 10px;
            margin-top: 10px;

            &-header {
                padding-top: 8px;
                display: flex;

                &-copy {
                    font-size: 12px;
                    margin-top: 5px;
                    margin-left: auto;
                    padding-right: 10px;

                    .iconfont {
                        font-size: 20px;
                    }
                }
            }
        }
    }

    .detail-table-item-row {
        font-size: @subFontSize;
        font-weight: @subFontWeight;
        color: @subFontColor;
        margin: 6px 0 0 15px;
        display: flex;
        height: 24px;
        line-height: 24px;

        .item-info {
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 80px;
            white-space:nowrap
        }

        .item-info-split {
            width: 6px;
            text-align: center;
        }

        .detail-table-item-col-info-right {
            margin-left: auto;
            padding-right: 10px;
            text-align: right;
        }

        .detail-table-item-total-amount {
            color: @contentFontColor;

            &-value {
                color: @contentFontColor;
            }
        }

        .detail-table-item-col-info-startday {
            color: @contentFontColor;
        }
    }

    .detail-table-item-row-spit-line {
        margin-top: 10px;
        width: 345px;
        height: 1px;
        background: #dfdfdf;
    }

    .bottom-info {
        position: fixed;
        bottom: 73px;
        width: 375px;
        height: 48px;
        line-height: 48px;
        background: #ffffff;
        box-shadow: 0px -0.5px 0px 0px #e8eaec; 
        display: flex;
        font-size: 12px;
        border-bottom: 1px solid #e8eaec;

        &-value {
            font-weight: bold;
        }

        &-operate {
            margin-top: 9px;
            margin-left: auto;
            padding-right: 10px;
            line-height: 0;
        }

        &-info {
            font-size: 14px;
            line-height: 18px;
            margin-top: 6px;
        }

        .mint-checklist {
            margin-top: 12px;
        }
    }
</style>


// WEBPACK FOOTER //
// index.vue?3764e620